import IPTInformation, {
    IPTImage,
    IPTPdf,
    IPTSlideEvent,
    IPTVideo,
    IUser,
    PTFileInfoType, PTSlideEventType,
    UserStatusType
} from "../interfaces/IPTInformation";
import {action, observable} from "mobx";
import URIs from "../const/URIs";
import request from "../utils/request";
import {pdfDoc2CanvasPage, pdfUrl2Canvas, pdfUrl2Doc} from "../utils/PdfUtills";
import config from "../config";

// import PPT from "../assets/testdata/ppt/PPT_sample.pdf";
// import PPT_IMAGE_1 from "../assets/testdata/pptThumbnail/PPT_sample-1.jpg";
// import PPT_IMAGE_2 from "../assets/testdata/pptThumbnail//PPT_sample-2.jpg";
// import PPT_IMAGE_3 from "../assets/testdata/pptThumbnail/PPT_sample-3.jpg";
// import PPT_IMAGE_4 from "../assets/testdata/pptThumbnail/PPT_sample-4.jpg";
// import PPT_IMAGE_5 from "../assets/testdata/pptThumbnail/PPT_sample-5.jpg";
// import PPT_IMAGE_6 from "../assets/testdata/pptThumbnail/PPT_sample-6.jpg";
// import PPT_IMAGE_7 from "../assets/testdata/pptThumbnail/PPT_sample-7.jpg";
// import PPT_IMAGE_8 from "../assets/testdata/pptThumbnail/PPT_sample-8.jpg";
// import PPT_IMAGE_9 from "../assets/testdata/pptThumbnail/PPT_sample-9.jpg";
// import VIDEO from "../assets/testdata/video/video.mp4";
import * as PDFJS from "pdfjs-dist";
PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.3.200/pdf.worker.js';

export default class PTInformation implements IPTInformation {
    @observable currentMarkerIndex: number;
    @observable currentSlide: number;
    @observable ptImages: IPTImage[];
    @observable ptPdf: IPTPdf;
    @observable ptSlideEvents: IPTSlideEvent[];
    @observable ptVideo: IPTVideo;
    @observable tempSlide: number;
    @observable user: IUser;
    @observable isBlind: boolean = false;
    @observable isLoaded: boolean = false;
    @observable isConvertPDF: boolean = false;
    @observable totalPage: number = 0;
    @observable loadingPage: number = 0;

    constructor() {
        this.currentMarkerIndex = -1;
        this.currentSlide = 1;
        this.ptImages = [{
            fileUrl: "",
            fileName: "",
            fileInfoType: PTFileInfoType.PT_IMAGE,
            fileDir: "",
            id: 0
        }];
        this.ptSlideEvents = [];
        this.ptPdf = {
            id: -1,
            fileDir: "",
            fileInfoType: PTFileInfoType.PT_PDF,
            fileName: "",
            fileUrl: ""
        };
        this.ptVideo = {
            id: -1,
            fileDir: "",
            fileInfoType: PTFileInfoType.PT_VIDEO,
            fileName: "",
            fileUrl: ""
        };
        this.tempSlide = 1;
        this.user = {
            domain: "",
            id: -1,
            name: "알 수 없음",
            ptCount: 0,
            recruitNoticeName: "알 수 없음",
            recruitSectorName: "알 수 없음",
            screeningName: "",
            subjectName: "",
            userCk: "",
            userStatusType: UserStatusType.READY
        }
    }

    @action
    init = async () => {
        try {
            await this.login();
            await this.getPTPdf();
            this.loadPTPdfImage();
            await this.loadPTSlideEvent();
            await this.loadPTVideo();
        } catch (e) {
            this.isConvertPDF = true;
        } finally {
            this.isLoaded = true;
        }
    };

    login = async () => {
        // let form = new FormData();
        // form.append('userCk', '12a75a1e17a14988');
        // form.append('evalCk ', '21');
        // await request({
        //     method: 'POST',
        //     url: URIs.login,
        //     data: form
        // });

        this.user = await request({
            method: 'GET',
            url: URIs.get_user,
        });

        // this.user = {
        //     domain: "",
        //     id: 0,
        //     name: "홍길동",
        //     ptCount: 0,
        //     recruitNoticeName: "2020년도 상반기 공개 채용",
        //     recruitSectorName: "웹 서비스 개발",
        //     screeningName: "screeningName",
        //     subjectName: "subjectName",
        //     userCk: "userCk",
        //     userStatusType: UserStatusType.COMPLETED
        // }
    };

    getPTPdf = async () => {
        this.ptPdf = await request({
            method: 'GET',
            url: URIs.pdf_upload,
        });

        // this.ptPdf = {
        //     id: 0,
        //     fileDir: "fileDir",
        //     fileInfoType: PTFileInfoType.PT_PDF,
        //     fileName: "나의PPT",
        //     fileUrl: PPT
        // };
    };

    loadPTPdfImage = async () => {
        // this.ptImages = await request({
        //     method: 'GET',
        //     url: URIs.get_pdf_img,
        // });

        // this.ptImages = (await pdfUrl2Canvas(this.ptPdf.fileUrl)).map((canvas, index) => {
        // // this.ptImages = (await pdfUrl2Canvas(`${config.hostRes}api/file/${this.ptPdf.id}`)).map((canvas, index) => {
        //     return {
        //         id: index,
        //         fileDir: `${config.hostRes}api/file/${this.ptPdf.id}`,
        //         fileInfoType: PTFileInfoType.PT_IMAGE,
        //         fileName: `${this.ptPdf.fileName}_${index}`,
        //         fileUrl: canvas.toDataURL()
        //     }
        // });

        // const doc = await pdfUrl2Doc(this.ptPdf.fileUrl);
        const doc = await pdfUrl2Doc(`${config.hostRes}api/file/${this.ptPdf.id}`);
        this.totalPage = doc.numPages;
        for(let i = 0; i < doc.numPages; i++) {
            this.loadingPage = i+1;
            const canvas = await pdfDoc2CanvasPage(doc, i);
            if(i === 0) {
                this.ptImages = [];
            }
            this.ptImages.push({
                id: i,
                fileDir: `${config.hostRes}api/file/${this.ptPdf.id}`,
                fileInfoType: PTFileInfoType.PT_IMAGE,
                fileName: `${this.ptPdf.fileName}_${i}`,
                fileUrl: canvas.toDataURL()
            })
        }

        this.isConvertPDF = true;
    };

    @action
    loadPTSlideEvent = async () => {
        this.ptSlideEvents = await request({
            method: 'GET',
            url: URIs.get_pt_slide_event,
        });

        // this.ptSlideEvents = [
        //     {
        //         "slideIndex": 0,
        //         "indexTime": 0,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {
        //         "slideIndex": 1,
        //         "indexTime": 4979,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 2, "indexTime": 11526, "slideEventType": PTSlideEventType.NEXT}, {
        //         "slideIndex": 3,
        //         "indexTime": 24061,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 4, "indexTime": 27470, "slideEventType": PTSlideEventType.NEXT}, {
        //         "slideIndex": 5,
        //         "indexTime": 32695,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 2, "indexTime": 39228, "slideEventType": PTSlideEventType.NEXT}, {
        //         "slideIndex": 7,
        //         "indexTime": 46057,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 4, "indexTime": 52332, "slideEventType": PTSlideEventType.NEXT}, {
        //         "slideIndex": 5,
        //         "indexTime": 69467,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 6, "indexTime": 80714, "slideEventType": PTSlideEventType.NEXT}, {
        //         "slideIndex": 2,
        //         "indexTime": 99496,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 3, "indexTime": 251235, "slideEventType": PTSlideEventType.NEXT}, {
        //         "slideIndex": 8,
        //         "indexTime": 329100,
        //         "slideEventType": PTSlideEventType.NEXT
        //     }, {"slideIndex": 8, "indexTime": 329390, "slideEventType": PTSlideEventType.NEXT}]

        const index = this.ptSlideEvents[0].slideIndex + 1;
        this.tempSlide = index;
        this.currentMarkerIndex = 0;
        this.currentSlide = index;
    };

    @action
    loadPTVideo = async () => {
        this.ptVideo = await request({
            method: 'GET',
            url: URIs.get_pt_video
        });
        // this.ptVideo = {
        //     id: 0,
        //     fileDir: "",
        //     fileInfoType: PTFileInfoType.PT_VIDEO,
        //     fileName: "",
        //     fileUrl: VIDEO
        // };

        let response = await new Promise(resolve => {

            var xhr = new XMLHttpRequest();

            // xhr.open( "GET", this.ptVideo.fileUrl, true );
            xhr.open( "GET", `${config.hostRes}api/file/${this.ptVideo.id}`, true );

            xhr.responseType = "arraybuffer";
            xhr.onload = function ( e ) {
                let arrayBufferView = new Uint8Array(xhr.response);
                let blob = new Blob( [ arrayBufferView ], { type: "video/mp4" } );
                let urlCreator = window.URL || window.webkitURL;
                let videoUrl = urlCreator.createObjectURL( blob );
                resolve(videoUrl);
                console.log(videoUrl);
            };
            xhr.send();
        });

        this.ptVideo.fileUrl = typeof response === "string" ? response : "";
    };
}